// src/components/common/Visuals/BackgroundBars.tsx
import React from "react";
import { motion, Variants } from "framer-motion";
import "../../../styles/components/backgroundBars.css";

export const BackgroundBars: React.FC<{ count?: number }> = ({ count = 9 }) => {
  const barVariants: Variants = {
    hidden: { scaleY: 0 },
    visible: (i) => ({
      scaleY: 1,
      transition: { duration: 1.2, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] },
    }),
  };

  const barHeights = [
    "60vh",
    "50vh",
    "40vh",
    "30vh",
    "20vh",
    "30vh",
    "40vh",
    "50vh",
    "60vh",
  ];
  return (
    <div className="bg-bars">
      {barHeights.map((height, i) => (
        <motion.div
          key={i}
          custom={i}
          variants={barVariants}
          className="bg-bar"
          style={{ height, transformOrigin: "bottom" }}
        />
      ))}
    </div>
  );
};
